import Pochta from "./Pochta";
function ENFJ()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
           <div className="image-wrapper">
     <img src="/img/ENFP Тренер.png" className="ENFJ"/>
     </div>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
       <div className="result">
         <h2>ENFJ</h2>
     <p><strong>Процент населения:</strong> 2–3%</p>
<p><strong>Среди мужчин:</strong> 1–2%</p>
<p><strong>Среди женщин:</strong> 3–4%</p>
<p><strong>Стратегия:</strong> Вдохновение и развитие</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  ENFJ черпают энергию из общения и помощи другим. 
  Им нужно быть рядом с людьми, вдохновлять и поддерживать. 
  Они восстанавливают силы, видя рост и счастье окружающих.
</p>
<p>
  Решения ENFJ принимают на основе чувств и ценностей. 
  Они доверяют своей интуиции и глубоко понимают других. 
  Они ценят гармонию, искренность и возможность влиять на мир.
</p>
<p>
  Это прирождённые учителя и лидеры. 
  Они всегда знают, как вдохновить и поддержать. 
  Им трудно говорить «нет», но их забота меняет жизни.
</p>

<p><strong>Особенность:</strong></p>
<p>
  ENFJ слишком много вкладывают в других. Они забывают о себе, растворяются в чужих проблемах. 
  Они чувствуют чужую боль как свою и могут выгорать, пытаясь всех спасти. 
  Их забота иногда становится навязчивой, и они обижаются, когда их советы игнорируют.
</p>

<p>
  ENFJ — это человек, который может вдохновить толпу одной фразой, а через час сидеть на кухне 
  и слушать чужую боль. Они — маяк, который светит другим, даже когда внутри шторм. 
  Их суперсила — заставлять людей становиться лучше, даже не прилагая усилий.
</p>

  </div>
  <Pochta/>
  </div>
   </div>
    </div>
       );
}
export default ENFJ;